import { useState } from "react";
import { LogOut } from "lucide-react";
import { signOut } from "@aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

export function SignOutButton({ collapsed }: { collapsed?: boolean }) {
  const [isSigningOut, setIsSigningOut] = useState(false);
  const navigate = useNavigate();

  async function handleSignOut() {
    setIsSigningOut(true);
    await signOut();
    setIsSigningOut(false);
    navigate("/login");
  }

  return (
    <button
      onClick={handleSignOut}
      disabled={isSigningOut}
      className={cn(
        "flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground disabled:opacity-50",
        collapsed && "md:justify-center md:px-0"
      )}
    >
      <LogOut className="size-4 shrink-0" />
      <span className={cn(collapsed && "md:hidden")}>
        {isSigningOut ? "Signing out..." : "Sign Out"}
      </span>
    </button>
  );
}
